// Work package "stakeholders": stakeholders, privacy, analytics and the funder view.
// This folder belongs to the WP (docs/v3/WORKPACKAGES.md 4). Other areas may
// import what this file exports (read-only use); they never edit this folder.
// Every route of this WP (docs/v3/COVERAGE.md), plus the pages that are not
// sitemap screens (edit a list, log a data request, the public privacy pages).
import { extra, page, screen, type AreaRoute } from "../../routes/types";
import { PAGES } from "@convenor/shared";

export const routes: AreaRoute[] = [
  // 7. Stakeholders
  screen(93, page(() => import("./pages/StakeholdersPage"), "StakeholdersPage")),
  screen(94, page(() => import("./pages/PersonPage"), "PersonPage")),
  extra(PAGES.stakeholdersDuplicates, page(() => import("./pages/DuplicatesPage"), "DuplicatesPage")),
  screen(95, page(() => import("./pages/PersonFormPage"), "AddPersonPage")),
  screen(96, page(() => import("./pages/PersonFormPage"), "EditPersonPage")),
  screen(97, page(() => import("./pages/ImportStakeholdersPage"), "ImportStakeholdersPage")),
  screen(98, page(() => import("./pages/OrganisationsPage"), "OrganisationsPage")),
  screen(99, page(() => import("./pages/OrganisationPage"), "OrganisationPage")),
  screen(100, page(() => import("./pages/ListsPage"), "ListsPage")),
  screen(101, page(() => import("./pages/ListFormPage"), "NewListPage")),
  screen(102, page(() => import("./pages/ListsPage"), "ListDetailPage")),
  extra(PAGES.stakeholdersListEdit, page(() => import("./pages/ListFormPage"), "EditListPage")),
  screen(103, page(() => import("./pages/PrivacyPage"), "PrivacyPage")),
  screen(104, page(() => import("./pages/DataRequestPage"), "DataRequestPage")),
  extra(PAGES.stakeholdersPrivacyRequestsNew, page(() => import("./pages/DataRequestPage"), "NewDataRequestPage")),
  // Settings › Tags (round 4): the organisation's tag list.
  extra(PAGES.settingsTags, page(() => import("./pages/TagsPage"), "TagsPage")),
  // 9. Analytics
  // 136 Overview and its five other views in the address (?view=, 153-157).
  screen([136, 153, 154, 155, 156, 157], page(() => import("./pages/AnalyticsPage"), "AnalyticsPage")),
  screen(137, page(() => import("./pages/ExportPage"), "ExportPage")),
  // Round 5 (AN6): the people behind a figure of Analytics.
  screen(152, page(() => import("./pages/AnalyticsPeoplePage"), "AnalyticsPeoplePage")),
  // 11. External views
  screen(144, page(() => import("./pages/FunderViewPage"), "FunderViewPage")),
  extra(PAGES.privacyRequest, page(() => import("./pages/PublicPrivacyPages"), "PrivacyRequestPage")),
  extra(PAGES.privacyConfirm, page(() => import("./pages/PublicPrivacyPages"), "ConsentConfirmPage")),
  extra(PAGES.yourInformation, page(() => import("./pages/PublicPrivacyPages"), "YourInformationPage")),
];
